module.exports = __webpack_public_path__ + "img/FinTurno-usuario2.edfbd953.png";